import React from "react";

import { Error } from "@mui/icons-material";
import {
  Box,
  FormLabel,
  Grid,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useParams } from "react-router-dom";

import { UrlParamTypes } from "../../../../types/org-display";
import ConfirmDialog from "../../../shared/confirm-dialog";
import { useTrainingMigrationContext } from "./context/training-migration-provider";

export const StartReverseTrainingMigrationDialog: React.FC<{
  regionCode: string;
}> = ({ regionCode }) => {
  const theme = useTheme();
  const { roleId } = useParams<UrlParamTypes>();
  const {
    reverseTrainingMigrationDialogOpen,
    setReverseTrainingMigrationDialogOpen,
    handleStartReverseTrainingMigration,
  } = useTrainingMigrationContext();

  return (
    <ConfirmDialog
      title="Start Reverse Training Migration"
      open={reverseTrainingMigrationDialogOpen}
      setOpen={setReverseTrainingMigrationDialogOpen}
      onConfirm={async () => {
        handleStartReverseTrainingMigration();
      }}
      width="md"
      cancelBtnLabel="Cancel"
      confirmBtnLabel="Confirm"
      onCancel={() => {
        setReverseTrainingMigrationDialogOpen(false);
      }}
    >
      <Grid container paddingTop={2}>
        <Grid item xs={12} container direction="column">
          <Box
            bgcolor={theme.palette.error.main}
            borderRadius="5px"
            border={1}
            borderColor={theme.palette.error.main}
            data-testid="reverse-training-migration-warning-panel"
          >
            <Grid container alignItems="center" padding={2}>
              <Grid item xs={2} container justifyContent="center">
                <Error fontSize="large" />
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body1" fontWeight="bold" gutterBottom>
                  WARNING: This action is irreversible!
                </Typography>
                <Typography variant="body2">
                  You are about to move training data back into the EdApp
                  infrastructure.
                </Typography>
                <Typography variant="body2" marginTop={1}>
                  <strong>
                    This workflow will delete all training data from
                    SafetyCulture!
                  </strong>
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Form Fields */}
        <Grid container direction="row" alignItems="center" paddingTop={2}>
          <Grid item xs={5}>
            <FormLabel disabled>Organisation ID</FormLabel>
          </Grid>
          <Grid item xs={7}>
            <TextField
              name="Organisation ID"
              inputProps={{
                "data-testid": "input-reverse-organisation-id",
              }}
              fullWidth
              disabled
              margin="normal"
              variant="outlined"
              value={roleId}
            />
          </Grid>
        </Grid>

        <Grid container direction="row" alignItems="center">
          <Grid item xs={9}>
            <FormLabel disabled>Region</FormLabel>
          </Grid>

          <Grid item xs={3}>
            <TextField
              name="Region"
              placeholder="AU, US, EU"
              inputProps={{
                "data-testid": "input-region",
              }}
              fullWidth
              margin="normal"
              variant="outlined"
              disabled
              value={regionCode}
            />
          </Grid>
        </Grid>
      </Grid>
    </ConfirmDialog>
  );
};
